// define meeting reducers.

import MeetingConst from "../constants/meeting.constants";

const MeetingDetailsReducer = (state = {}, action) => {
  // console.log("MeetingDetailsReducer");
  const initialState = state;
  initialState.displayKrConfidence = state['display_kr_confidence'] || false;
  switch (action.type) {
    case MeetingConst.MEETING_ADD_TOPIC_NEW:
      break;
    case MeetingConst.MEETING_CHANGE_PAGE:
      state = action.item;
      break;
    case MeetingConst.MEETING_UPDATE_TIMER_COUNTER:
      initialState.meeting = Object.assign(
        {},
        initialState.meeting,
        action.counter
      );
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_TAKEAWAY_SMARTWOBO_SCORE:
      // console.log('state', state);

      const takeExistsSmartWoboScore = initialState.meeting_takes.find(
        t => t.id == action.takeId
      );

      if (takeExistsSmartWoboScore) {
        initialState.meeting_takes = initialState.meeting_takes.map(take => {
          // find the item to change
          if (take.id === action.takeId) {
            take.smartWoboScore = action.score;
          }
          return take;
        });
      } else {
        initialState.meeting_takes.push({
          id: action.takeId,
          smartWoboScore: action.score
        });
      }
      // this is to ensure only one dialog is open at a time
      if (action.score > 0.5) {
        initialState.inlineDialogCurrentlyOpen = action.takeId;
      }

      state = { ...state, initialState };

      // console.log('final state', state);
      break;
    case MeetingConst.MEETING_UPDATE_TAKEAWAY_SHOW_SMARTWOBO:
      const takeExistsShowSmartWobo = initialState.meeting_takes.find(
        t => t.id == action.takeId
      );

      if (takeExistsShowSmartWobo) {
        initialState.meeting_takes = initialState.meeting_takes.map(take => {
          // find the item to change
          if (take.id === action.takeId) {
            take.showSmartWoboDialog = action.showDialog;
          }
          return take;
        });
      } else {
        initialState.meeting_takes.push({
          id: action.takeId,
          showSmartWoboDialog: action.showDialog
        });
      }
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_TAKEAWAYS_RESET_SMARTWOBO:
      if (action.resetValue) {
        initialState.meeting_takes = [];
      }

      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_TAKEAWAY_IGNORE_SMARTWOBO:
      const takeExistsShowSmartWoboIgnore = initialState.meeting_takes.find(
        t => t.id == action.takeId
      );

      if (takeExistsShowSmartWoboIgnore) {
        initialState.meeting_takes = initialState.meeting_takes.map(take => {
          // find the item to change
          if (take.id === action.takeId) {
            take.showSmartWoboDialog = false;
          }
          return take;
        });
      } else {
        initialState.meeting_takes.push({
          id: action.takeId,
          showSmartWoboDialog: false
        });
      }
      initialState.inlineDialogCurrentlyOpen = 0;

      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_SYNC_DATA:
      if (typeof action.item === "object" && Object.keys(action.item).length) {
        const syncData = action.item;
        const syncDataType = syncData.type ? syncData.type.toLowerCase() : "";
        const syncDataAction = syncData.action ? syncData.action : "";
        if (syncDataType == "topic" && typeof syncData.data === "object") {
          if (syncDataAction == "add") {
            const findTopic = initialState.meeting_topics.find(
              t => t.id == syncData.data.id
            );
            if (!findTopic) {
              const addData = Object.assign({}, syncData.data, {
                canEdit: false,
                canDelete: false
              });
              initialState.meeting_topics = initialState.meeting_topics.concat(
                addData
              );
            }
          } else if (
            syncDataAction == "tag_update" ||
            syncDataAction == "update"
          ) {
            initialState.meeting_topics = initialState.meeting_topics.map(t => {
              if (t.id == syncData.data.id) {
                t = Object.assign({}, t, syncData.data);
              }
              return t;
            });
          } else if (syncDataAction == "delete") {
            initialState.meeting_topics = initialState.meeting_topics.filter(
              t => t.id !== syncData.data.id
            );
          } else if (syncDataAction == "delete_topic_attc") {
            const topicId =
              syncData.topicId !== "undefined" && syncData.topicId > 0
                ? syncData.topicId
                : "";
            if (topicId && syncDataType == "topic") {
              initialState.meeting_topics = initialState.meeting_topics.map(
                t => {
                  if (t.id == topicId) {
                    t.files = t.files.filter(tt => tt.id != syncData.data.id);
                  }
                  return t;
                }
              );
            }
          } else if (syncDataAction == "add_topic_attc") {
            const topicId =
              syncData.topicId !== "undefined" && syncData.topicId > 0
                ? syncData.topicId
                : "";
            if (topicId && syncDataType == "topic") {
              initialState.meeting_topics = initialState.meeting_topics.map(
                t => {
                  if (t.id == topicId) {
                    if (typeof t.files === "undefined") {
                      t.files = [];
                    }
                    const findFile = t.files.find(
                      tt => tt.id == syncData.data.id
                    );
                    if (!findFile) {
                      const addData = Object.assign({}, syncData.data, {
                        canEdit: false,
                        canDelete: false
                      });
                      t.files = [...t.files, addData];
                    }
                  }
                  return t;
                }
              );
            }
          } else if (syncDataAction == "discuss_topic") {
            const topicId =
              syncData.topicId !== "undefined" && syncData.topicId > 0
                ? syncData.topicId
                : "";
            if (topicId && syncDataType == "topic") {
              initialState.meeting_topics = initialState.meeting_topics.map(
                t => {
                  if (t.id == topicId) {
                    t.topic_to_discuss = syncData.data.value;
                  } else {
                    t.topic_to_discuss = false;
                  }
                  return t;
                }
              );
              initialState.meeting.topic_discuss = syncData.data.value;
            }
          }
        }
        if (
          (syncDataType == "take" || syncDataType == "nontake") &&
          typeof syncData.data === "object"
        ) {
          const topicId =
            syncData.topicId !== "undefined" && syncData.topicId > 0
              ? syncData.topicId
              : "";
          if (syncDataAction == "add") {
            if (topicId && syncDataType == "take") {
              initialState.meeting_topics = initialState.meeting_topics.map(
                t => {
                  if (t.id == topicId) {
                    const findTake = t.topic_take.find(
                      tt => tt.id == syncData.data.id
                    );
                    if (!findTake) {
                      const addData = Object.assign({}, syncData.data, {
                        canEdit: false,
                        canDelete: false
                      });
                      t.topic_take = t.topic_take.concat(addData);
                    }
                  }
                  return t;
                }
              );
            } else {
              const findTake = initialState.meeting_takes.find(
                tt => tt.id == syncData.data.id
              );
              if (!findTake) {
                const addData = Object.assign({}, syncData.data, {
                  canEdit: false,
                  canDelete: false
                });
                initialState.meeting_takes = initialState.meeting_takes.concat(
                  addData
                );
              }
            }
          } else if (
            syncDataAction == "tag_update" ||
            syncDataAction == "update"
          ) {
            if (topicId && syncDataType == "take") {
              initialState.meeting_topics = initialState.meeting_topics.map(
                t => {
                  if (t.id == topicId) {
                    t.topic_take = t.topic_take.map(tt => {
                      if (tt.id == syncData.data.id) {
                        tt = Object.assign({}, tt, syncData.data);
                      }
                      return tt;
                    });
                  }
                  return t;
                }
              );
            } else {
              initialState.meeting_takes = initialState.meeting_takes.map(t => {
                if (t.id == syncData.data.id) {
                  t = Object.assign({}, t, syncData.data);
                }
                return t;
              });
            }
          } else if (syncDataAction == "delete") {
            if (topicId && syncDataType == "take") {
              initialState.meeting_topics = initialState.meeting_topics.map(
                t => {
                  if (t.id == topicId) {
                    t.topic_take = t.topic_take.filter(
                      tt => tt.id != syncData.data.id
                    );
                  }
                  return t;
                }
              );
            } else {
              initialState.meeting_takes = initialState.meeting_takes.filter(
                t => t.id !== syncData.data.id
              );
            }
          } else if (syncDataAction == "delete_take_attc") {
            if (topicId && syncDataType == "take") {
              initialState.meeting_topics = initialState.meeting_topics.map(
                t => {
                  if (t.id == topicId) {
                    t.topic_take = t.topic_take.map(tt => {
                      const takeid =
                        syncData.takeid !== "undefined" && syncData.takeid > 0
                          ? syncData.takeid
                          : "";
                      if (tt.id == takeid) {
                        tt.files = tt.files.filter(
                          item => item.id != syncData.data.id
                        );
                        if (tt.files.length > 0) {
                          return tt;
                        }
                        tt.files = [];

                        return tt;
                      }
                      return tt;
                    });
                  }
                }
              );
            }
          } else if (syncDataAction == "add_take_attc") {
            if (topicId && syncDataType == "take") {
              initialState.meeting_topics = initialState.meeting_topics.map(
                topic => {
                  if (topic.id == topicId) {
                    topic.topic_take = topic.topic_take.map(take => {
                      const takeid =
                        syncData.takeid !== "undefined" && syncData.takeid > 0
                          ? syncData.takeid
                          : "";
                      if (take.id == takeid) {
                        if (typeof take.files === "undefined") {
                          take.files = [];
                        }
                        const findFile = take.files.find(
                          tt => tt.id == syncData.data.id
                        );
                        if (!findFile) {
                          const addData = Object.assign({}, syncData.data, {
                            canEdit: false,
                            canDelete: false
                          });
                          take.files = [...take.files, addData];
                        }
                      }
                      return take;
                    });
                  }
                  return topic;
                }
              );
            }
          } else if (syncDataAction == "discuss_takeaway") {
            if (topicId && syncDataType == "take") {
              initialState.meeting_topics = initialState.meeting_topics.map(
                topic => {
                  if (topic.id == topicId) {
                    topic.topic_take = topic.topic_take.map(take => {
                      const takeid =
                        syncData.data.id !== "undefined" && syncData.data.id > 0
                          ? syncData.data.id
                          : "";
                      if (take.id == takeid) {
                        take.takeaway_to_discuss = syncData.data.value;
                      } else {
                        take.takeaway_to_discuss = false;
                      }
                      return take;
                    });
                  }
                  return topic;
                }
              );
            }
          }
        }
        if (syncDataType == "wobo_object") {
          if (Array.isArray(syncData.data) && syncData.data.length) {
            const addedUserData = initialState.currentUser;
            const woboObjectData = syncData.data.filter(w => {
              const _findW = initialState.meeting_topics.find(
                f => f.id == w.id
              );
              if (!_findW) {
                w.canEdit = false;
                w.canDelete = false;
                w.topic_take = [];
                // w.firstname = addedUserData.firstname;
                // w.lastname = addedUserData.lastname;
                w.firstname =
                  typeof syncData.firstname !== "undefined"
                    ? syncData.firstname
                    : addedUserData.firstname;
                w.lastname =
                  typeof syncData.lastname !== "undefined"
                    ? syncData.lastname
                    : addedUserData.lastname;
                return w;
              }
              return false;
            });
            if (woboObjectData.length) {
              initialState.meeting_topics = initialState.meeting_topics.concat(
                woboObjectData
              );
            }
          }
        }
        state = { ...state, initialState };
      }
      break;
    case MeetingConst.MEETING_UPDATE_TIMER_STATUS:
      initialState.meeting = Object.assign(
        {},
        initialState.meeting,
        action.item
      );
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_POPUP_DATA:
      if (typeof action.item.meeting !== "undefined") {
        initialState.meeting = Object.assign(
          {},
          initialState.meeting,
          action.item.meeting
        );
      }
      if (typeof action.item.meeting_invitees !== "undefined") {
        initialState.meeting_invitees = action.item.meeting_invitees;
      }
      if (typeof action.item.dropDownDate !== "undefined") {
        initialState.dateDropdown = initialState.dateDropdown.map(d => {
          if (d.id == initialState.meeting.id) {
            d.name = action.item.dropDownDate;
          }
          return d;
        });
      }
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_NEW_TOPIC:
      initialState.meeting_topics.unshift(action.value);
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_TOPICS:
      initialState.meeting_topics = action.value;
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_ADD_TOPIC_ITEMS:
      let _addItems = action.value;
      const _currentUser = initialState.currentUser;
      if (action.defaultAttr) {
        const _defaultAttr = {
          canEdit: true,
          canDelete: true,
          recurringTopic: 0,
          topic_take: [],
          files: [],
          firstname: _currentUser.firstname,
          lastname: _currentUser.lastname
        };
        if (Array.isArray(_addItems)) {
          console.log("inside array");
          _addItems = _addItems.map(item => {
            item = Object.assign({}, item, _defaultAttr);
            return item;
          });
        } else if (Object.keys(_addItems).length) {
          console.log("inside object");
          _addItems = Object.assign({}, _addItems, _defaultAttr);
        }
      }
      if (action.defaultAttr && Array.isArray(_addItems)) {
        let finalArray = [];
        initialState.meeting_topics = initialState.meeting_topics.map(m => {
          let findItem = _addItems.find(a => a.id == m.id);
          if (findItem) {
            finalArray.push(m.id);
            m = { ...m, ...findItem };
          }
          return m;
        });
        _addItems = _addItems.filter(a => !finalArray.includes(a.id))
        initialState.meeting_topics = _addItems.concat(
          initialState.meeting_topics
        );
      } else {
        initialState.meeting_topics.unshift(_addItems);
      }
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_TOPIC_TAKE_UPDATE:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.takeId) {
          topic.topic_take = topic.topic_take.map(take => {
            if (take.id == action.topicId) {
              take = Object.assign({}, take, action.item);
            }
            return take;
          });
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_ADD_TOPIC_TAG:
      initialState.meeting_topics = initialState.meeting_topics.map(
        topictag => {
          if (topictag.id == action.id) {
            topictag.tag = action.tagId;
            if (typeof action.item === "object") {
              topictag = Object.assign({}, topictag, action.item);
            }
          }
          return topictag;
        }
      );
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_ADD_NON_TOPIC_TAG:
      initialState.meeting_takes = initialState.meeting_takes.map(
        nontopictag => {
          if (nontopictag.id == action.id) {
            nontopictag.tag = action.tagId;
            if (typeof action.item === "object") {
              nontopictag = Object.assign({}, nontopictag, action.item);
            }
          }
          return nontopictag;
        }
      );

      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_ADD_TAKE_TAG:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.topicId) {
          topic.topic_take = topic.topic_take.map(take => {
            if (take.id == action.id) {
              take.tag = action.tagId;
              if (typeof action.item === "object") {
                take = Object.assign({}, take, action.item);
              }
            }
            return take;
          });
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_TOPIC_UPDATE:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.topicId) {
          topic = Object.assign({}, topic, action.item);
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_NON_TAKE_UPDATE:
      initialState.meeting_takes = initialState.meeting_takes.map(nontake => {
        if (nontake.id == action.topicId) {
          nontake = Object.assign({}, nontake, action.item);
        }
        return nontake;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_ADD_TAKEAWAY_ITEM:
      initialState.meeting_takes = initialState.meeting_takes.concat(
        action.value
      );
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_ADD_TOPIC_TAKEAWAY_ITEM:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.topicId) {
          if (!("topic_take" in topic)) {
            topic.topic_take = [];
          }
          topic.topic_take = topic.topic_take.concat(action.item);
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_DELETE_TOPIC:
      // initialState.meeting_topics = initialState.meeting_topics.filter(topic => (topic.id != action.ids));
      initialState.meeting_topics = initialState.meeting_topics.filter(
        obj => obj.id != action.ids
      );
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_DELETE_NON_TOPIC_TAKEAWAY:
      initialState.meeting_takes = initialState.meeting_takes.filter(
        note => note.id != action.ids
      );
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_DELETE_TOPIC_TAKEAWAY:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.item.topicId) {
          topic.topic_take = topic.topic_take.filter(
            item => item.id != action.ids
          );
          if (topic.topic_take.length > 0) {
            return topic;
          }
          topic.topic_take = [];

          return topic;
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_PACE_VALUES:
      const { currentUser } = initialState;
      const paceValues = action.value;
      const { meeting } = initialState;
      initialState.meeting_pace = Object.assign(
        {},
        initialState.meeting_pace,
        paceValues
      );
      if (Object.keys(initialState.meeting_trends.series).length) {
        const userSeries =
          initialState.meeting_trends.series[`${currentUser.id}`];
        for (const pace in userSeries) {
          let paceV = null;
          if (pace == "p") paceV = paceValues.perform;
          else if (pace == "c") paceV = paceValues.comp;
          else if (pace == "a") paceV = paceValues.align;
          else if (pace == "e") paceV = paceValues.engage;
          else if (pace == "a5") paceV = paceValues.attribute5;
          else if (pace.startsWith('custom_')) {
            // Handle custom attributes
            const customAttrId = pace.replace('custom_', '');
            const customRating = paceValues.custom_pace_ratings?.find(
              rating => rating.attributeId == customAttrId
            );
            paceV = customRating ? customRating.rating : null;
          }
          for (const meetId in userSeries[pace]) {
            if (meetId == meeting.id) {
              userSeries[pace][meetId] = paceV == null ? null : parseInt(paceV);
            }
          }
        }
        initialState.meeting_trends.series[`${currentUser.id}`] = userSeries;
      } else {
        const userSeriesData = {
          p: [
            {
              [`${meeting.id}`]:
                paceValues.perform == null
                  ? null
                  : parseInt(paceValues.perform)
            }
          ],
          e: [
            {
              [`${meeting.id}`]:
                paceValues.engage == null ? null : parseInt(paceValues.engage)
            }
          ],
          a: [
            {
              [`${meeting.id}`]:
                paceValues.align == null ? null : parseInt(paceValues.align)
            }
          ],
          c: [
            {
              [`${meeting.id}`]:
                paceValues.comp == null ? null : parseInt(paceValues.comp)
            }
          ],
          a5: [
            {
              [`${meeting.id}`]:
                paceValues.attribute5 == null ? null : parseInt(paceValues.attribute5)
            }
          ]
        };

        // Add custom attributes to the series data
        if (paceValues.custom_pace_ratings && Array.isArray(paceValues.custom_pace_ratings)) {
          paceValues.custom_pace_ratings.forEach(customRating => {
            const key = `custom_${customRating.attributeId}`;
            userSeriesData[key] = [
              {
                [`${meeting.id}`]:
                  customRating.rating == null ? null : parseInt(customRating.rating)
              }
            ];
          });
        }

        initialState.meeting_trends.series = {
          [`${currentUser.id}`]: userSeriesData
        };
      }
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_TRENDS:
      initialState.meeting_trends = action.value;
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_TOPIC_ID:
      initialState.meeting_topics = initialState.meeting_topics.map(
        topictag => {
          if (topictag.id == action.tempAiId) {
            topictag = Object.assign({}, topictag, action.item);
            if (typeof action.item.topic_take === "undefined") {
              topictag.topic_take = [];
            }
          }
          return topictag;
        }
      );
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_NON_TAKEAWAY_ID:
      initialState.meeting_takes = initialState.meeting_takes.map(
        nontopictag => {
          if (nontopictag.id == action.tempAiId) {
            nontopictag.id = action.newId;
            nontopictag = Object.assign({}, nontopictag, action.item);
          }
          return nontopictag;
        }
      );
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_TOPIC_TAKE_ID:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.topicRelId) {
          topic.topic_take = topic.topic_take.map(take => {
            if (take.id == action.tempAiId) {
              take.id = action.newId;
              take = Object.assign({}, take, action.item);
            }
            return take;
          });
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_SHARE_TOPIC:
      initialState.meeting_topics = initialState.meeting_topics.map(
        topicShare => {
          if (topicShare.id == action.id) {
            topicShare.access = action.item.access;
          }
          return topicShare;
        }
      );
      state = { ...state, initialState };
      break;

    case MeetingConst.MEETING_UPDATE_OBJECT:
      if (initialState.meeting.id == action.id) {
        initialState.meeting.objective = action.item.objective;
      }
      return initialState;
      state = { ...state, initialState };
      break;

    case MeetingConst.MEETING_UPDATE_INVITEES:
      if (initialState.meeting.id == action.id) {
        initialState.meeting_invitees = action.item.inviteeVal;
      }
      state = { ...state, initialState };
      break;

    case MeetingConst.MEETING_REMOVE_INVITEE:
      initialState.meeting_invitees = initialState.meeting_invitees.filter(
        item => item.user_id != action.item.userId
      );
      state = { ...state, initialState };
      break;

    case MeetingConst.MEETING_UPDATE_INVITEE_ACCESS:
      initialState.meeting_invitees = initialState.meeting_invitees.map(
        invitee => {
          if (invitee.user_id == action.item.userId) {
            invitee.is_admin = action.item.isAdminVal;
          }
          return invitee;
        }
      );
      state = { ...state, initialState };
      break;

    case MeetingConst.MEETING_UPDATE_USER_TEAM:
      initialState.userTeamList = action.item.userTeamList;
      state = { ...state, initialState };
      break;

    case MeetingConst.MEETING_NAME_UPDATE:
      initialState.meeting.name = action.item.meetingName;
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_SORT_ITEM:
      var items = action.item.item;
      if (action.id == 1) {
        initialState.meeting_topics = items;
      } else {
        initialState.meeting_takes = items;
      }
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_SORT_TAKE_ITEM:
      var items = action.item.item;
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.id) {
          topic.topic_take = [];
          topic.topic_take = topic.topic_take.concat(items);
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_DELETE_TOPIC_ATTACHMENT:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.id) {
          topic.files = topic.files.filter(item => item.id != action.item.id);
          if (topic.files.length > 0) {
            return topic;
          }
          topic.files = [];

          return topic;
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_DELETE_NOTE_ATTACHMENT:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.topicid) {
          topic.topic_take = topic.topic_take.map(tt => {
            if (tt.id == action.takeid) {
              tt.files = tt.files.filter(item => item.id != action.item.id);
              if (tt.files.length > 0) {
                return tt;
              }
              tt.files = [];

              return tt;
            }
            return tt;
          });
          return topic;
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_ADD_TOPIC_ATTACHMENT:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.id) {
          if (!("files" in topic)) {
            topic.files = [];
          }
          const addData = Object.assign({}, action.item.item);
          topic.files = topic.files.concat(addData);
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_TOPIC_ATTACHMENT:
        initialState.meeting_topics = initialState.meeting_topics.map(topic => {
          if (topic.id == action.id) {
            const processFile = action.item.item;
            if (topic.files.length > 0) {
              topic.files.map(files => {
                if (files.file_id == processFile.id && files.fusStatus == '2' ) {
                  files.fusStatus = processFile.fus_status
                }
                return files;
              })
            }
          }
          return topic;
        });
        state = { ...state, initialState };
        break;
    case MeetingConst.MEETING_ADD_NOTE_ATTACHMENT:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.topicid) {
          topic.topic_take = topic.topic_take.map(take => {
            if (take.id == action.takeid) {
              if (!("files" in take)) {
                take.files = [];
              }
              const addData = Object.assign({}, action.item.item);
              take.files = take.files.concat(addData);
            }
            return take;
          });
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_UPDATE_NOTE_ATTACHMENT:
        initialState.meeting_topics = initialState.meeting_topics.map(topic => {
          if (topic.id == action.topicid) {
            topic.topic_take = topic.topic_take.map(take => {
              if (take.id == action.takeid) {                
                const processFile = action.item.item;
                if (take.files.length > 0) {
                  take.files.map(files => {
                    if (files.file_id == processFile.id && files.fusStatus == '2' ) {
                      files.fusStatus = processFile.fus_status
                    }
                    return files;
                  })
                }
              }
              return take;
            });
          }
          return topic;
        });
        state = { ...state, initialState };
        break;
    case MeetingConst.UPDATE_MEETING_S3DATA:
      if (action.objType && action.value) {
        initialState[action.objType] = action.value;
        state = { ...state, initialState };
      }
      break;
    case MeetingConst.ADD_REMOVE_ITEM_RECURRING:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.id) {
          topic.recurringTopic = action.value;
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.ADD_REMOVE_ALL_ITEM_RECURRING:
      console.log(action.value);
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (action.meetingId) {
          topic.recurringTopic = action.value;
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_TOPIC_DISCUSS:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.id) {
          topic.topic_to_discuss = action.value;
        } else {
          topic.topic_to_discuss = false;
        }
        return topic;
      });
      initialState.meeting.topic_discuss = action.value;
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_TAKE_DISCUSS:
      initialState.meeting_topics = initialState.meeting_topics.map(topic => {
        if (topic.id == action.topicId) {
          topic.topic_take = topic.topic_take.map(take => {
            if (take.id == action.id) {
              console.log(action.value);
              take.takeaway_to_discuss = action.value;
            } else {
              take.takeaway_to_discuss = false;
            }
            return take;
          });
        }
        return topic;
      });
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_SEND_MINUTES_UPDATE:
      initialState.meeting.send_minutes = action.state;
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_WS_UPDATE:
      if (action.id) {
        initialState.meeting.ws_id = action.id;
      }
      if (action.name) {
        initialState.meeting.wsName = action.name;
      }
      state = { ...state, initialState };
      break;
    case MeetingConst.MEETING_SET_TAKE_SMART_WOBO_ID:
      state = { ...state, takeSmartWoboId: action.payload };
      break;
    default:
      break;
  }
  return state;
};

export default MeetingDetailsReducer;
